import { WarningAmber } from '@mui/icons-material'
import { Chip, Tooltip } from '@mui/material'
import { useIntl } from 'react-intl'
import messages from './messages'
import { FederationProviderDomain } from './types'

// One chip per federation domain (E12 F12-6, WI 636/637). A domain linked to an E3 Verified domain
// (verifiedDomainId set) shows green; an unlinked grandfathered domain (verifiedDomainId null) shows a
// warning chip + caution tooltip prompting the re-link. No v1 write path produces unlinked rows yet —
// rendered defensively per the grandfathered-import decision, ready for that import.
const DomainBadge = ({ domain }: { domain: FederationProviderDomain }) => {
  const { formatMessage } = useIntl()

  if (domain.verifiedDomainId != null) {
    return <Chip size='small' color='success' variant='outlined' label={domain.domainName} />
  }

  return (
    <Tooltip title={formatMessage(messages.domainUnverifiedCaution)}>
      <Chip
        size='small'
        color='warning'
        variant='outlined'
        icon={<WarningAmber />}
        label={domain.domainName}
      />
    </Tooltip>
  )
}

export default DomainBadge
